import React, { useState } from 'react';
import { ListGroup, Container, Tabs, Tab, Form } from 'react-bootstrap';
import './filter.scss'; // Ensure you import the CSS file

const Filter = ({ items = [], filter, onFilterChange, onItemClick, selectedItem }) => {
    // State for search term
    const [searchTerm, setSearchTerm] = useState('');

    // Filter items based on the selected filter status and search term
    const filteredItems = items.filter(item => {
        const matchesStatus = filter === 'All' || item.status === filter;
        const matchesSearch = 
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
            item.isin.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesStatus && matchesSearch;
    });

    return (
        <Container className='filter-list'>
            {/* Search bar */}
            <Form.Control
                type="text"
                placeholder="Search by name or ISIN..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="mb-3 rounded"
            />

            <Tabs
                id="filter-tabs"
                activeKey={filter}
                onSelect={(k) => onFilterChange(k)}
                className="mb-3 tab-container"
            >
                <Tab eventKey="All" title="All" />
                <Tab eventKey="Active" title="Active" />
                <Tab eventKey="Matured" title="Matured" />
            </Tabs>

            <ListGroup>
                {filteredItems.length > 0 ? (
                    filteredItems.map(item => (
                        <ListGroup.Item
                            key={item.id}
                            action
                            onClick={() => onItemClick(item)}
                            active={selectedItem?.id === item.id}
                            className='list-group-item'
                        >
                            <div className={`status-circle ${item.status === 'Active' ? 'active' : 'inactive'}`}></div>
                            <div className='item-content'>
                                <p className='report-item'>{item.name}</p>
                                <p className='report-isbn'>ISIN: {item.isin}</p>
                            </div>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item>No reports available.</ListGroup.Item>
                )}
            </ListGroup>
        </Container>
    );
};

export default Filter;
